import { render } from "./AjaxButton.vue?vue&type=template&id=158759cc"
import script from "./AjaxButton.vue?vue&type=script&lang=js"
export * from "./AjaxButton.vue?vue&type=script&lang=js"

import "./AjaxButton.vue?vue&type=style&index=0&id=158759cc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__